import { Layout } from '@/containers/layout';
import { ErrorBoundary } from '@components/error-boundary';
import { UsersSection } from './components/sections/users';
import { RolesSection } from './components/sections/roles';
import { FilialSection } from './components/sections/filial';
import { StatisticsSection } from './components/sections/statistics';
import { Box } from '@mantine/core';
import { SafetySection } from './components/sections/safety';
import { useAppSelector } from '@/hooks/redux/redux';
import { MailSection } from './components/sections/mail';
import { DiskSpaceSection } from './components/sections/diskSpace';
import { useStyles } from './styles';
import { ModulesSection } from './components/sections/modules';
import { PaymentSection } from './components/sections/payment';
import { isSaaS } from '@/lib/utils/access';
import { ServicesSection } from './components/sections/services';

export const Home = () => {
  const { classes } = useStyles();
  const { Settings } = useAppSelector((state) => state.userInfo);
  const currentUserFilial = useAppSelector((state) => state.userInfo?.User?.Customer.Id);

  const urlParams = new URLSearchParams(window.location.search);
  const paymentsDate = urlParams.get('paymentsDate');

  return (
    <ErrorBoundary componentTitle="Home page">
      <Layout>
        <Box className={classes.homeContainer}>
          <Box className={classes.homeColumns}>
            <UsersSection filialId={currentUserFilial} />
            <MailSection filialId={currentUserFilial} />
            <RolesSection />
            {isSaaS(Settings) && (
              <PaymentSection filialId={currentUserFilial} paymentsDate={paymentsDate} />
            )}
            <ServicesSection filialId={currentUserFilial} />
            <StatisticsSection />
            <DiskSpaceSection filialId={currentUserFilial} />
            <FilialSection filialId={currentUserFilial} />
            <ModulesSection filialId={currentUserFilial} />
            <SafetySection filialId={currentUserFilial} />
          </Box>
        </Box>
      </Layout>
    </ErrorBoundary>
  );
};
